import { httpsCallable } from "firebase/functions";
import { cloudFunctions } from "./getFunctions";
import { CloudFunctionResponse } from "@fixeduy/restaurantestypes";

export interface AgregarSectorParams {
  nombre: string;
  orden?: number;
}

const agregarSector = async (
  data: string | AgregarSectorParams
): Promise<CloudFunctionResponse> => {
  const run = httpsCallable<any, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );

  const result = await run({
    func: "crearSector",
    params: data
  } as any);

  return result.data;
};

export { agregarSector };

